import { ReactNode } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

export interface IAnimateOpacityProps {
  children: ReactNode
  initialOpacity?: number
  animateOpacity?: number
  exitOpacity?: number
  transitionDuration?: number
}

export const AnimateOpacity = ({
  children,
  initialOpacity = 0,
  animateOpacity = 1,
  exitOpacity = 0,
  transitionDuration = 0.25,
}: IAnimateOpacityProps) => (
  <AnimatePresence>
    <motion.div
      initial={{ opacity: initialOpacity }}
      animate={{ opacity: animateOpacity }}
      exit={{ opacity: exitOpacity }}
      transition={{ duration: transitionDuration }}
    >
      {children}
    </motion.div>
  </AnimatePresence>
)
